import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NotificationService } from '../../../../../../common/services';
import { AllocationViewTruckReleaseModel } from '../../models';
import { HttpErrorResponse } from '@angular/common/http';
import {
  AllocationViewTruckReleaseAction,
  AllocationViewTruckReleaseActionPrepare,
  AllocationViewTruckReleaseActionSetInitialState,
} from './allocation-view-truck-release-action.actions';
import { AllocationViewTruckReleaseActionService } from './allocation-view-truck-release-action.service';
import { AllocationViewActionBaseState } from '../base';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AllocationViewTruckReleaseActionStateModel {
  loaded: boolean;
  preparedDetails: AllocationViewTruckReleaseModel;
}

const initialState: AllocationViewTruckReleaseActionStateModel = {
  loaded: false,
  preparedDetails: null,
};

@State({
  name: 'allocationViewActionsTruckRelease',
  defaults: initialState,
})
@Injectable()
export class AllocationViewTruckReleaseActionState extends AllocationViewActionBaseState {
  @Selector()
  static getLoaded(state: AllocationViewTruckReleaseActionStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getPreparedDetails(state: AllocationViewTruckReleaseActionStateModel): AllocationViewTruckReleaseModel {
    return state.preparedDetails;
  }

  constructor(
    private allocationViewTruckReleaseActionService: AllocationViewTruckReleaseActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewTruckReleaseAction)
  truckRelease(
    ctx: StateContext<AllocationViewTruckReleaseActionStateModel>,
    { data }: AllocationViewTruckReleaseAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewTruckReleaseActionService.truckRelease(data).pipe(
      tap(() => {
        this.finishAction('api.uli.success.truckRelease');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewTruckReleaseActionPrepare)
  truckReleasePrepare(
    ctx: StateContext<AllocationViewTruckReleaseActionStateModel>,
    { identifier, language }: AllocationViewTruckReleaseActionPrepare,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | AllocationViewTruckReleaseModel> {
    return this.allocationViewTruckReleaseActionService.truckReleasePrepare(identifier, language).pipe(
      tap((response: AllocationViewTruckReleaseModel) => {
        ctx.patchState({
          preparedDetails: response,
          loaded: true,
        });
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewTruckReleaseActionSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewTruckReleaseActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }
}
